var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Trash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.289,
    height: 22.5,
    viewBox: "0 0 19.289 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_434",
    "data-name": "Caminho 434",
    d: "M13.153,20A1.153,1.153,0,0,0,12,21.153V31.768a4.3,4.3,0,0,0,4.3,4.3h7.465a4.3,4.3,0,0,0,4.3-4.3V21.153A1.153,1.153,0,0,0,26.918,20Zm3.668,11.25a.8.8,0,1,1-1.607,0V24.018a.8.8,0,1,1,1.607,0Zm4.018,0a.8.8,0,1,1-1.607,0V24.018a.8.8,0,1,1,1.607,0Zm4.018,0a.8.8,0,1,1-1.607,0V24.018a.8.8,0,1,1,1.607,0Z",
    transform: "translate(-10.392 -13.571)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_435",
    "data-name": "Caminho 435",
    d: "M27.284,7.56A1.258,1.258,0,0,0,26,6.411H21.233a.378.378,0,0,1-.378-.378V5.607A1.607,1.607,0,0,0,19.248,4H16.034a1.607,1.607,0,0,0-1.607,1.607v.426a.378.378,0,0,1-.378.378H9.284A1.258,1.258,0,0,0,8,7.56,1.205,1.205,0,0,0,9.2,8.821H26.078A1.205,1.205,0,0,0,27.284,7.56ZM19.248,6.009a.4.4,0,0,1-.4.4H16.436a.4.4,0,0,1,0-.8h2.411A.4.4,0,0,1,19.248,6.009Z",
    transform: "translate(-7.997 -4)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.25961178.svg";
export { ForwardRef as ReactComponent };